<script setup lang="ts">
    import { defineAsyncComponent } from 'vue';
    import TopBannerRight from '../components/oferta/TopBannerRight.vue'
    import FormarBloque from '../components/oferta/FormarBloqueNeo.vue';
    const DocPlanEstudios = defineAsyncComponent(() => import('../components/oferta/DocPlanEstudios.vue')) ; 
const PoliticaIA = defineAsyncComponent(() => import('../components/oferta/PoliticaIA.vue'))
    const CalendarioOferta = defineAsyncComponent(() => import('../components/oferta/CalendarioOferta.vue')) ;
    // const DescargaFolleto = defineAsyncComponent(() => import('../components/oferta/DescargaFolleto.vue')) ; 
    // const DocExcelenciaAcadem = defineAsyncComponent(() => import('../components/oferta/DocExcelenciaAcadem.vue')) ; 
    const VerModelo = defineAsyncComponent(() => import('../components/oferta/VerModelo.vue')) ;
</script>

<template>
    <TopBannerRight
        :img="'background-image: url(../../pagesImages/docs-ocs-educ2.jpg);'"
        :nivel="'Doctorado en'"
        :carrera="'Educaci&oacute;n'"
        :frase="'Aprender es como remar contra corriente: en cuanto se deja, se retrocede'"
        :autor="'Edward Benjamin Britten'"
    />

    <FormarBloque
        :img="'../../pagesImages/square-doc-edu.jpg'"
        :link="'/requisitos-doctorado'"
        alt="Mujer con doctorado en Educación Universidad Humanitas"
        :frase="'Agentes de cambio educativo con herramientas para diagnosticar problemas y diseñar soluciones que eleven la calidad institucional'"
        :testo1="'Combina investigación rigurosa sobre teorías pedagógicas, diseño curricular y gestión institucional con un enfoque práctico para desarrollar soluciones que mejoren la calidad educativa.'"
        :testo2="'El programa profundiza en tendencias de transformación curricular, innovación en el aula y liderazgo educativo.'"
        :testo3="'Este programa está diseñado para profesionales que buscan revolucionar el ámbito educativo desde diferentes roles como: Directores de instituciones educativas, docentes, diseñadores de programas de formación, así como consultores y asesores pedagógicos.'"
    />

    <div class="flex items-center justify-center my-10">
    </div>

    <DocPlanEstudios
        :ejecutivo="true"
    />

    <VerModelo esco=""
    ejec="/pagesImages/Programas/Doctorado/doctorado-educacion-ejecutivo.webp"
    virt=""
    :escoT="false"
    :ejecT="true"
    :virtT="false" />

    <CalendarioOferta nombre="Doctorado en Educación" :titulo="'Calendario del doctorado'" :subtitulo="'Conoce el programa de doctorado que consolidará.'"
  :inicios="[true, false, false, false, true, false, false, false]"></CalendarioOferta>

    <!-- <DocExcelenciaAcadem class="mb-16" />

    <section class="flex items-center justify-center mb-16 w-full">
		<div class="lg:flex flex-col px-4 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
			<div class="flex flex-col justify-between">
				<div class="lg:flex items-center justify-center">
                    <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12">
                        <h2>
                            <span class="block text-hgold text-left font-serif mb-3 text-[42px]">Metodología</span>
                        </h2>
                        <p class="mb-4">
                            El modelo ejecutivo se desarrolla bajo la siguiente estructura:
                        </p>
                        <ul class="list-disc pl-5 mb-4">
                            <li>Consta de 6 bloques semestrales.</li>
                            <li>Cada bloque equivale a tres materias fusionadas, impartidas por un especialista en la materia.</li>
                            <li>Se imparten clases un día a la semana, tres horas de clases presenciales.</li>
                            <li>El modelo educativo tiene una duración de diez semanas de clases, y una semana adicional culminando con una evaluación final.</li>
                            <li>La evaluación se compone de participación en clase, foros, trabajos y examen final, integrando así un proceso de aprendizaje integral.</li>
                        </ul>
                        <p>
                            Este modelo permite a los estudiantes desarrollar habilidades especializadas con un enfoque práctico y estratégico, alineado con las exigencias del mundo profesional actual.
                        </p>
                    </div>
                    <div class="flex items-center justify-center w-full lg:max-w-[520px]">
						<img src="/pagesImages/universidad-fisica-virtual.webp" alt="Estudiantes de maestría en alta dirección corporativa universidad Humanitas" class="w-full lg:max-w-[520px]"/>
					</div>
                </div>
			</div>
		</div>
	</section> -->

    <section class="flex items-center justify-center mb-16 w-full">
		<div class="lg:flex flex-col lg:px-4 px-8 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
			<div class="flex flex-col justify-between">
				<div class="lg:flex items-center justify-center">
                    <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12">
                        <h2>
                            <span class="block font-serif text-[42px] text-hgold text-left" style="">Estructura académica</span>
                            <span class="sr-only whitespace-nowrap">&nbsp;</span>
                            <span class="block text-xl text-left mb-3">(Bloques semestrales):</span>
                        </h2>
                        <ul class="list-disc pl-5 mb-4">
                            <li><b>Contexto de la Educación:</b> Temas selectos sobre Educación, tendencias en la aplicación de la tecnología educativa y proyecto de investigación e innovación en la Educación I.</li>
                            <li><b>Transformación del currículum:</b> Tendencias en diseño curricular, innovación en educación y proyecto de investigación e innovación en la Educación II.</li>
                            <li><b>Transformación del aula:</b> Tendencias en el proceso de aprendizaje y enseñanza, proyecto de investigación e innovación en la Educación III.</li>
                            <li><b>Gestión y dirección:</b> Gestión de la Educación, dirección y liderazgo en instituciones educativas y proyecto de investigación e innovación en la Educación IV.</li>
                        </ul>
                    </div>
                    <div class="flex items-center justify-center w-full lg:max-w-[520px]">
						<img src="/pagesImages/estructura-academica-doctorados.webp" alt="Alt pendiente" class="w-full lg:max-w-[520px]"/>
					</div>
                </div>
			</div>
		</div>
	</section>

    <section class="lg:flex items-center justify-center bg-cover bg-[center] bg-no-repeat mb-16" style="background-image: url(/pagesImages/madin3.jpg); position: relative; background-attachment: fixed; background-position: left; background-repeat: no-repeat; background-size: cover; overflow: hidden; transition: transform 0.3s ease;">
        <div class="lg:flex items-center justify-center w-full h-full my-16">
            <div class="lg:flex items-center justify-between w-full max-w-[1200px]">
                <img src="/pagesImages/graduado-doctorado.webp" alt="Ejecutivo con doctorado en Educación Universidad Humanitas" class="lg:p-0 w-full lg:max-w-[520px] md:px-16 px-6 pt-6"/>
                <div class="flex flex-col lg:justify-start justify-center items-center lg:items-start lg:w-[50%] w-full lg:my-24 py-12 text-justify md:px-0  px-12">
                    <h2>
                        <span class="block text-[28px] text-hwine leading-none text-center md:text-left">Perfil del egresado de</span>
                        <span class="sr-only whitespace-nowrap">&nbsp;</span>
                        <span class="block text-hwine text-[42px] mb-4 leading-tight text-center md:text-left font-serif ">Doctorado en Educación</span>
                    </h2>
                    <p class="text-justify text-gray-800 hyphens-auto">Profesionales con visión crítica, capacidad analítica y compromiso con la mejora continua de los procesos educativos.<br>Está preparado para diagnosticar, diseñar e implementar soluciones innovadoras a problemáticas pedagógicas e institucionales, sustentadas en fundamentos teóricos y metodológicos sólidos.</p>
                    <br>
                    <router-link to="/contacto">
                        <div class="flex items-center justify-center w-[140px] h-[35px] hover:bg-hwine bg-hgold text-white  text-lg transition duration-300 ease-in-out">
                            <span>Inscr&iacute;bete</span>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </section>

    <section class="flex items-center justify-center mb-16 w-full">
		<div class="lg:flex flex-col px-4 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
			<div class="flex flex-col justify-between w-full">
				<div class="lg:flex items-center justify-center">
                    <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12">
                        <h2>
                            <span class="block leading-none text-left text-[28px]" style="">Cinco razones para elegir</span>
                            <span class="sr-only whitespace-nowrap">&nbsp;</span>
                            <span class="block text-hgold text-left font-serif mb-3 text-[42px]">Universidad Humanitas:</span>
                        </h2>
                        <ul class="list-disc pl-5 mb-4">
                            <li>Modelo educativo especializado.</li>
                            <li>Excelencia académica.</li>
                            <li>Instalaciones de primer nivel.</li>
                            <li>Costos accesibles.</li>
                            <li>Acreditaciones reconocidas (SEP, ESR y GPTW).</li>
                        </ul>
                    </div>
                    <div class="flex items-center justify-center w-full lg:max-w-[520px]">
						<img src="/pagesImages/beneficios-estudiar-universidad-humanitas.webp" alt="Beneficios de estudiar en Universidad Humanitas" class="w-full lg:max-w-[520px]"/>
					</div>
                </div>
			</div>
		</div>
	</section>
    <PoliticaIA />
</template>

<style scoped>
</style>